import api from '../config/api';
import { User } from './authService';

export type { User };

export interface PaginatedResponse<T> {
  results: T[];
  count: number;
  next: string | null;
  previous: string | null;
}

export const userService = {
  getAll: async (filters?: { page?: number; page_size?: number }): Promise<PaginatedResponse<User>> => {
    const params: any = {};
    if (filters?.page) params.page = filters.page;
    if (filters?.page_size) params.page_size = filters.page_size;
    const response = await api.get('/accounts/users/', { params });
    if (response.data.results) {
      return {
        results: response.data.results,
        count: response.data.count || response.data.results.length,
        next: response.data.next || null,
        previous: response.data.previous || null
      };
    }
    const allData = Array.isArray(response.data) ? response.data : [response.data];
    return {
      results: allData,
      count: allData.length,
      next: null,
      previous: null
    };
  },

  getById: async (id: number): Promise<User> => {
    const response = await api.get(`/accounts/users/${id}/`);
    return response.data;
  },

  update: async (id: number, data: Partial<User>): Promise<User> => {
    const response = await api.patch(`/accounts/users/${id}/`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/accounts/users/${id}/`);
  },
};

